import { WIKIDATA_CITY_SAMEAS } from '@/server/constants/wikidataCityMapping';

const getLocalBusinessSchema = (
  siteName: string,
  countryCode: string,
  categoryName: string,
  cityDisplayName: string,
  pageUrl: string,
  citySlug?: string,
): TMetaLocalBusiness => {
  const sameAs = citySlug ? WIKIDATA_CITY_SAMEAS[citySlug] : undefined;

  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: `${siteName} — ${categoryName} in ${cityDisplayName}`,
    url: pageUrl,
    areaServed: {
      '@type': 'City',
      name: cityDisplayName,
      addressCountry: countryCode,
      ...(sameAs && { sameAs }),
    },
  };
};

export default getLocalBusinessSchema;
